import { render, staticRenderFns } from "./IDPFrom.vue?vue&type=template&id=ae482c2c"
import script from "./IDPFrom.vue?vue&type=script&lang=js"
export * from "./IDPFrom.vue?vue&type=script&lang=js"
import style0 from "./IDPFrom.vue?vue&type=style&index=0&id=ae482c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports